module.exports = __webpack_public_path__ + "img/ipl-logo.ef65cefc.png";